import {
  format as formatDateFns,
  parseISO as parseISODateFns,
} from 'date-fns'

export function formatDate (value, format) {
  return formatDateFns(parseISODateFns(value), format)
}
